import React from 'react'

import { User } from 'core/application/account/loginUser'
import { Permissions } from 'core/application/account/permissions'
import employeeSignupState from 'core/application/employeeSignup/employeeSignupState'
import employeeSignupWizard from 'core/application/employeeSignup/employeeSignupWizard'

import useLoginUser from 'common/hooks/useLoginUser'

import EmployeeSignup from '../../common/EmployeeSignup'
import { EENavItemsMapping } from '../EmployeeSignupStepsMapping'

export const EMPLOYEE_SIGNUP_FLOW_PATH = '/ee-signup-flow'

interface EligibleEmployeeSignupProps {}

const QseHraEligibleEmployeeSignup: React.FC<EligibleEmployeeSignupProps> = () => {
  const [loginUser] = useLoginUser()

  const userIsAllowedToEnterEmployeeSignUpFlow = (user: User): boolean => {
    return user?.permissions.includes(Permissions.AccessEligibleEmployeeSignupWizard)
  }

  return (
    <EmployeeSignup
      signupFlowPath={EMPLOYEE_SIGNUP_FLOW_PATH}
      isUserAllowedToEnterSignupFlow={userIsAllowedToEnterEmployeeSignUpFlow(loginUser)}
      employeeSignupWizard={employeeSignupWizard}
      employeeSignupStateApi={employeeSignupState}
      navItemsMapping={EENavItemsMapping}
    />
  )
}

export default QseHraEligibleEmployeeSignup
